var React = require('react');

function SafetyLarge (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.9 4.9L12.2.3c-.2-.1-.5-.1-.7 0L3.1 4.9c-.3.1-.4.3-.4.6v6c0 5.1 3 9.7 7.7 11.7l1.2.5c.1 0 .2.1.3.1.1 0 .2 0 .3-.1l1.3-.6c4.8-2 7.8-6.6 7.8-11.8V5.5c0-.3-.1-.5-.4-.6zm-1.1 1v5.5c0 4.6-2.7 8.7-7 10.5l-1 .4-.8-.4C6.9 20.1 4.2 16 4.2 11.5V5.9l7.7-4.2 7.9 4.2z","key":0}),React.createElement("path",{"d":"M10.1 14.7c.1.2.4.3.6.3.2 0 .3-.1.5-.2l5.3-4.3c.2-.1.2-.3.3-.5s0-.4-.2-.5c-.1-.2-.3-.2-.5-.3-.2 0-.4 0-.5.2l-4.8 3.9L9 11.2c-.3-.3-.7-.3-1-.1-.1.1-.2.3-.3.5 0 .2 0 .4.2.5l2.2 2.6z","key":1})]);
}

SafetyLarge.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = SafetyLarge;

SafetyLarge.default = SafetyLarge;
